import { render } from "./Cms.vue?vue&type=template&id=632528af&scoped=true"
import script from "./Cms.vue?vue&type=script&lang=js"
export * from "./Cms.vue?vue&type=script&lang=js"

import "./Cms.vue?vue&type=style&index=0&id=632528af&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632528af"]])

export default __exports__